// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Favorite.module.scss  */
.Favorite-module-Root_34E {
  position: relative;
  flex-shrink: 0;
  cursor: pointer; }
  .Favorite-module-Root_34E::after {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    content: '';
    opacity: 0;
    border-radius: inherit;
    background: var(--favorite-background-checked);
    transition: opacity 0.2s ease; }
  .Favorite-module-Root_34E:focus .Favorite-module-Icon_1B_ {
    filter: drop-shadow(0 0 2px var(--favorite-box-shadow-color-svg)); }
  .Favorite-module-Root_34E svg path {
    transition: all 0.3s ease; }
  .Favorite-module-Root_34E[aria-pressed='true'] svg path {
    fill: var(--favorite-icon-fill-checked); }

.Favorite-module-IconWrapper_D2f {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  user-select: none; }

.Favorite-module-FlyHearts_NNm {
  position: absolute;
  top: -90%;
  left: -83%;
  overflow: visible; }

.Favorite-module-n1FlyHeart_uch,
.Favorite-module-n3FlyHeart_1DJ,
.Favorite-module-n5FlyHeart_2Iz {
  animation-delay: 0.2s; }

.Favorite-module-hasEmphasis_221 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* stylelint-disable */
  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 58.67%), linear-gradient(274.22deg, #f7f6fe 47.14%, #eee8fe 97.95%);
  /* stylelint-enable */ }
  .Favorite-module-hasEmphasis_221:focus {
    box-shadow: 0 0 3px 3px var(--favorite-box-shadow-color); }

.Favorite-module-animate_1Vm .Favorite-module-n1FlyHeart_uch,
.Favorite-module-animate_1Vm .Favorite-module-n2FlyHeart_3jQ,
.Favorite-module-animate_1Vm .Favorite-module-n5FlyHeart_2Iz {
  animation: Favorite-module-flyLeftTop_HyM 0.4s ease 1 forwards; }

.Favorite-module-animate_1Vm .Favorite-module-n3FlyHeart_1DJ,
.Favorite-module-animate_1Vm .Favorite-module-n4FlyHeart_-xJ {
  animation: Favorite-module-flyRightTop_1P- 0.4s ease 1 forwards; }

@keyframes Favorite-module-flyLeftTop_HyM {
  0% {
    transform: translate(0, 0); }
  20% {
    transform: translate(-5%, -10%); }
  40% {
    transform: translate(-2%, -30%); }
  60% {
    transform: translate(0, -40%); }
  80% {
    opacity: 0.5;
    transform: translate(2%, -50%); }
  100% {
    opacity: 0;
    transform: translate(5%, -60%); } }

@keyframes Favorite-module-flyRightTop_1P- {
  0% {
    transform: translate(0, 0); }
  20% {
    transform: translate(5%, -10%); }
  40% {
    transform: translate(2%, -30%); }
  60% {
    transform: translate(0, -40%); }
  80% {
    transform: translate(-2%, -50%); }
  100% {
    opacity: 0;
    transform: translate(-5%, -60%); } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Favorite/Favorite.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAE;EACjB;IACE,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,cAAc;IACd,eAAe;IACf,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,8CAA8C;IAC9C,6BAA6B,EAAE;EACjC;IACE,iEAAiE,EAAE;EACrE;IACE,yBAAyB,EAAE;EAC7B;IACE,uCAAuC,EAAE;;AAE7C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB,EAAE;;AAErB;;;EAGE,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,+IAA+I;EAC/I,qBAAqB,EAAE;EACvB;IACE,wDAAwD,EAAE;;AAE9D;;;EAGE,8DAA8D,EAAE;;AAElE;;EAEE,+DAA+D,EAAE;;AAEnE;EACE;IACE,0BAA0B,EAAE;EAC9B;IACE,+BAA+B,EAAE;EACnC;IACE,+BAA+B,EAAE;EACnC;IACE,6BAA6B,EAAE;EACjC;IACE,YAAY;IACZ,8BAA8B,EAAE;EAClC;IACE,UAAU;IACV,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,0BAA0B,EAAE;EAC9B;IACE,8BAA8B,EAAE;EAClC;IACE,8BAA8B,EAAE;EAClC;IACE,6BAA6B,EAAE;EACjC;IACE,+BAA+B,EAAE;EACnC;IACE,UAAU;IACV,+BAA+B,EAAE,EAAE","sourcesContent":["/*  imported from Favorite.module.scss  */\n.Favorite-module-Root_34E {\n  position: relative;\n  flex-shrink: 0;\n  cursor: pointer; }\n  .Favorite-module-Root_34E::after {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    width: inherit;\n    height: inherit;\n    content: '';\n    opacity: 0;\n    border-radius: inherit;\n    background: var(--favorite-background-checked);\n    transition: opacity 0.2s ease; }\n  .Favorite-module-Root_34E:focus .Favorite-module-Icon_1B_ {\n    filter: drop-shadow(0 0 2px var(--favorite-box-shadow-color-svg)); }\n  .Favorite-module-Root_34E svg path {\n    transition: all 0.3s ease; }\n  .Favorite-module-Root_34E[aria-pressed='true'] svg path {\n    fill: var(--favorite-icon-fill-checked); }\n\n.Favorite-module-IconWrapper_D2f {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  user-select: none; }\n\n.Favorite-module-FlyHearts_NNm {\n  position: absolute;\n  top: -90%;\n  left: -83%;\n  overflow: visible; }\n\n.Favorite-module-n1FlyHeart_uch,\n.Favorite-module-n3FlyHeart_1DJ,\n.Favorite-module-n5FlyHeart_2Iz {\n  animation-delay: 0.2s; }\n\n.Favorite-module-hasEmphasis_221 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* stylelint-disable */\n  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 58.67%), linear-gradient(274.22deg, #f7f6fe 47.14%, #eee8fe 97.95%);\n  /* stylelint-enable */ }\n  .Favorite-module-hasEmphasis_221:focus {\n    box-shadow: 0 0 3px 3px var(--favorite-box-shadow-color); }\n\n.Favorite-module-animate_1Vm .Favorite-module-n1FlyHeart_uch,\n.Favorite-module-animate_1Vm .Favorite-module-n2FlyHeart_3jQ,\n.Favorite-module-animate_1Vm .Favorite-module-n5FlyHeart_2Iz {\n  animation: Favorite-module-flyLeftTop_HyM 0.4s ease 1 forwards; }\n\n.Favorite-module-animate_1Vm .Favorite-module-n3FlyHeart_1DJ,\n.Favorite-module-animate_1Vm .Favorite-module-n4FlyHeart_-xJ {\n  animation: Favorite-module-flyRightTop_1P- 0.4s ease 1 forwards; }\n\n@keyframes Favorite-module-flyLeftTop_HyM {\n  0% {\n    transform: translate(0, 0); }\n  20% {\n    transform: translate(-5%, -10%); }\n  40% {\n    transform: translate(-2%, -30%); }\n  60% {\n    transform: translate(0, -40%); }\n  80% {\n    opacity: 0.5;\n    transform: translate(2%, -50%); }\n  100% {\n    opacity: 0;\n    transform: translate(5%, -60%); } }\n\n@keyframes Favorite-module-flyRightTop_1P- {\n  0% {\n    transform: translate(0, 0); }\n  20% {\n    transform: translate(5%, -10%); }\n  40% {\n    transform: translate(2%, -30%); }\n  60% {\n    transform: translate(0, -40%); }\n  80% {\n    transform: translate(-2%, -50%); }\n  100% {\n    opacity: 0;\n    transform: translate(-5%, -60%); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
